import React from 'react';
import { ProFormSelect } from '@ant-design/pro-form';
import { useQuery, gql } from '@apollo/client';
import { Space, Typography } from 'antd';
const { Text } = Typography;

const GET_PROJECT_STATUS = gql`
  query GET_PROJECT_STATUS($ids: [ID!], $state: State) {
    projectStatus(ids: $ids, state: $state) {
      id
      name
      description
    }
  }
`;

const SelectProjectStatus = ({ ...props }) => {
  const { data, loading } = useQuery(GET_PROJECT_STATUS, {
    variables: { state: 'ACTIVE' },
  });
  const options = loading
    ? []
    : data.projectStatus?.map(({ id, name, description }) => ({
        value: id,
        label: name,
        description,
      }));
  return (
    <ProFormSelect
      fieldProps={{
        loading,
        optionItemRender(item) {
          return (
            <Space direction="vertical">
              {item.label}
              <Text type="secondary">{item.description}</Text>
            </Space>
          );
        },
      }}
      placeholder="Select Project Status"
      width="xl"
      name="projectStatus"
      label="Project Status"
      options={options}
      {...props}
    />
  );
};

export default SelectProjectStatus;
